import { render, staticRenderFns } from "./ArticleFeature.vue?vue&type=template&id=0f2cdc01&scoped=true&"
import script from "./ArticleFeature.vue?vue&type=script&lang=js&"
export * from "./ArticleFeature.vue?vue&type=script&lang=js&"
import style0 from "./ArticleFeature.vue?vue&type=style&index=0&id=0f2cdc01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2cdc01",
  null
  
)

export default component.exports